module.exports = __webpack_public_path__ + "img/twitter-sm.0681fa85.svg";